module.exports = __webpack_public_path__ + "static/media/get_a_studio.6c607ce0.png";